<template>
  <div>
    <Loader ref="Loader"></Loader>
    <v-flex xs12>
      <v-card>
        <v-toolbar dense color="secondary" dark>
          <v-toolbar-title>Report Summary</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <!-- FILTER -->
        <v-flex xs12 sm12 lg12>
          <v-card elevation-5 dark>
            <v-card-title class="title">Filters</v-card-title>
            <v-layout ma-2>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-combobox
                  label="Select customer"
                  v-model="selectedCustomer"
                  :items="customerItems"
                  item-text="Name"
                  item-value="ID"
                  @change="FetchVenues()"
                ></v-combobox>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-combobox
                  label="Select venue"
                  v-model="selectedVenue"
                  :items="venueItems"
                  item-text="Name"
                  item-value="ID"
                  :disabled="selectedCustomer == null"
                ></v-combobox>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="startDateFormatted"
                      label="Start Date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="event"
                      @blur="startDate = parseStartDate(startDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" no-title @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-menu
                  ref="menu1"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endDateFormatted"
                      label="End Date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="event"
                      @blur="endDate = parseEndDate(endDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <!-- <v-date-picker v-model="endDate" no-title @input=""> -->
                  <v-date-picker v-model="endDate" no-title @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout justify-end ma-2 row>
              <v-btn flat outline @click="filterItems()">Filter</v-btn>
              <v-btn flat outline @click="clearFilter()">Clear Filter</v-btn>
            </v-layout>
          </v-card>
        </v-flex>
        <!-- SUPERVISOR -->
        <v-layout ma-2>
          <v-flex xs3>
            <h3>Supervisor</h3>
          </v-flex>
        </v-layout>
        <v-layout row wrap ma-2>
          <!-- Widgets-->
          <v-flex d-flex lg6 sm6 xs12>
            <widget
              icon="group_work"
              :count="SupervisorTasksComplete"
              supTitle="Inspections completed"
              color="#0866C6"
            />
          </v-flex>
          <v-flex d-flex lg6 sm6 xs12>
            <widget
              icon="watch_later"
              :title="SupervisorEfficiency"
              supTitle="Supervisor efficiency of tasks complete vs tasks incomplete"
              color="#1D2939"
            />
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <v-layout row wrap ma-3>
            <v-flex xs12 lg12 pa-2>
              <v-card>
                <table>
                  <thead>
                    <tr>
                      <th>Reference</th>
                      <th>Inspection</th>
                      <th>Total Complete</th>
                      <th>Total Incomplete</th>
                      <th>View Detail</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,idx) in SupervisorInspections" :key="idx">
                      <td>{{ item.Reference }}</td>
                      <td>{{ item.Name }}</td>
                      <td>{{ item.AmountComplete }}</td>
                      <td>{{ item.AmountIncomplete }}</td>
                      <td>
                        <span>Click to view</span>
                        <v-btn
                          fab
                          small
                          @click="GetSupervisorInspectionItemTXes(item)"
                          color="success"
                        >
                          <v-icon>remove_red_eye</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-card>
            </v-flex>
          </v-layout>

          <v-container>
            <v-flex xs4>
              <v-text-field
                append-icon="search"
                v-model="search"
                placeholder="Search supervisor tasks"
              ></v-text-field>
            </v-flex>
            <v-data-table
              class="table"
              :headers="superVisorHeaders"
              :items="superVisorItems"
              :rows-per-page-items="[25, 50, 100]"
              :search="search"
            >
              <template v-slot:items="props">
                <td>{{ props.index+1 }}</td>
                <td class="text-xs-left">{{ props.item.Date }}</td>
                <td class="text-xs-left">{{ props.item.Supervisor }}</td>
                <td class="text-xs-left">{{ props.item.Inspection }}</td>
                <td class="text-xs-left">{{ props.item.Reference }}</td>
                <td class="text-xs-left">{{ props.item.InspectionItem }}</td>
                <td class="text-xs-left">{{ props.item.Completed }}</td>
                <td class="text-xs-left">{{ props.item.Comments }}</td>
                <td
                  class="text-xs-left"
                  v-if="props.item.FilePath != null && props.item.FilePath.length > 0"
                >
                  <v-btn flat outline color="secondary" @click="showImage(props.item.ID)">View photo</v-btn>
                </td>
                <td class="text-xs-left" v-else>No Image</td>
              </template>
            </v-data-table>
          </v-container>
        </v-flex>
        <!-- SUPERVISOR TABLE -->

        <!-- OPS-MANAGER -->
        <v-layout ma-2>
          <v-flex xs3>
            <h3>Ops Manager</h3>
          </v-flex>
        </v-layout>
        <v-layout row wrap ma-2>
          <!-- Widgets-->
          <v-flex d-flex lg3 sm6 xs12>
            <widget
              icon="domain"
              :count="OpsSuccessfulVisits"
              supTitle="Successful customer visits"
              color="#00b297"
            />
          </v-flex>
          <v-flex d-flex lg3 sm6 xs12>
            <widget
              icon="domain"
              :count="OpsUnsuccessfulVisits"
              supTitle="Unsuccessful customer visits"
              color="#dc3545"
            />
          </v-flex>
          <v-flex d-flex lg3 sm6 xs12>
            <widget
              icon="group_work"
              :count="OpsManagerTasksComplete"
              supTitle="Inspections completed"
              color="#0866C6"
            />
          </v-flex>
          <v-flex d-flex lg3 sm6 xs12>
            <widget
              icon="watch_later"
              :title="OpsManagerEfficiency"
              supTitle="Ops manager efficiency of tasks complete vs tasks incomplete"
              color="#1D2939"
            />
          </v-flex>
        </v-layout>
        <v-container>
          <v-flex xs4>
            <v-text-field
              append-icon="search"
              v-model="searchOps"
              placeholder="Search ops manager tasks"
            ></v-text-field>
          </v-flex>
          <v-data-table
            class="table"
            :headers="opsManagerItemHeaders"
            :items="opsManagerItems"
            :rows-per-page-items="[25, 50, 100]"
            :search="searchOps"
          >
            <template v-slot:items="props">
              <td>{{ props.index+1 }}</td>
              <td class="text-xs-left">{{ props.item.DateTime }}</td>
              <td class="text-xs-left">{{ props.item.OpsManager }}</td>
              <td class="text-xs-left">{{ props.item.Type }}</td>
              <td class="text-xs-left">{{ props.item.Inspection }}</td>
              <td class="text-xs-left">{{ props.item.Complete }}</td>
              <td class="text-xs-left">{{ props.item.CustomerComments }}</td>
              <td class="text-xs-left">{{ props.item.OpsComments }}</td>
              <td class="text-xs-left">{{ props.item.CustomerRating }}</td>
              <td class="text-xs-left">{{ props.item.OpsRating }}</td>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-flex>
    <v-dialog v-model="showPhoto" max-width="600px">
      <v-flex xs12>
        <v-card>
          <v-toolbar dense color="secondary" dark>
            <v-toolbar-title>Photo Taken</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-layout fill-height>
            <v-img v-if="photoUrl != null" :src="photoUrl"></v-img>
          </v-layout>
        </v-card>
      </v-flex>
    </v-dialog>
  </div>
</template>

<script>
import Widget from "./report-components/Widget.vue";
import DataTable from "./report-components/DataTable.vue";
import TimeLine from "./report-components/TimeLine.vue";
import LocationStatistic from "./report-components/LocationStatistic.vue";
import SiteViewStatistic from "./report-components/SiteViewStatistic.vue";
import TotalEarningsStatistic from "./report-components/TotalEarningsStatistic.vue";
import moment from "moment";
import JWT from "jsonwebtoken";

export default {
  data() {
    return {
      role: null,
      userID: 0,
      startDate: null,
      endDate: null,
      startDateFormatted: this.formatStartDate(
        new Date().toISOString().substr(0, 10)
      ),
      endDateFormatted: this.formatEndDate(
        new Date().toISOString().substr(0, 10)
      ),
      menu1: false,
      menu2: false,
      CheckInsForToday: 0,
      today: moment(Date.now()).format("YYYY-MM-DD"),
      customerItems: [],
      selectedCustomer: null,
      venueItems: [],
      selectedVenue: null,
      NumberOfCompletedSupervisorTasksForToday: null,
      SupervisorInspectionsCompletedToday: 0,
      NumberOfCompletedOpsTasksForToday: null,
      OpsInspectionsCompletedToday: 0,
      CompleteIncomplete: {
        Complete: 0,
        Incomplete: 0,
        Total: 0,
        Efficiency: ""
      },
      superVisorItems: [],
      opsManagerItems: [],
      superVisorHeaders: [
        {},
        {
          value: "Date",
          text: "Date",
          align: "left",
          sortable: true
        },
        {
          text: "Supervisor",
          value: "Supervisor",
          align: "left",
          sortable: true
        },
        {
          text: "Inspection",
          value: "Inspection",
          align: "left",
          sortable: true
        },
        {
          text: "Reference",
          value: "Reference",
          align: "left",
          sortable: true
        },
        {
          text: "Inspection Item",
          value: "InspectionItem",
          align: "left",
          sortable: true
        },
        {
          text: "Completed",
          value: "Completed",
          align: "left",
          sortable: true
        },
        {
          text: "Comments",
          value: "Comments",
          align: "left",
          sortable: true
        },
        {
          text: "FilePath",
          value: "FilePath",
          align: "left",
          sortable: true
        }
      ],
      opsManagerItemHeaders: [
        {},
        {
          value: "DateTime",
          text: "Date",
          align: "left",
          sortable: true
        },
        {
          text: "Ops Manager",
          value: "OpsManager",
          align: "left",
          sortable: true
        },
        {
          text: "Type",
          value: "Type",
          align: "left",
          sortable: true
        },
        {
          text: "Inspection",
          value: "Inspection",
          align: "left",
          sortable: true
        },
        {
          text: "Complete",
          value: "Complete",
          align: "left",
          sortable: true
        },
        {
          text: "Customer Comments",
          value: "CustomerComments",
          align: "left",
          sortable: true
        },
        {
          text: "Ops Manager Comments",
          value: "OpsComments",
          align: "left",
          sortable: true
        },
        {
          text: "Customer Rating",
          value: "CustomerRating",
          align: "left",
          sortable: true
        },
        {
          text: "Ops Manager Rating",
          value: "OpsRating",
          align: "left",
          sortable: true
        }
      ],
      showPhoto: false,
      photoUrl: null,
      SupervisorTasksComplete: 0,
      SupervisorTasksIncomplete: 0,
      SupervisorEfficiency: null,
      OpsManagerTasksComplete: 0,
      OpsManagerTasksIncomplete: 0,
      OpsManagerEfficiency: null,
      OpsSuccessfulVisits: 0,
      OpsUnsuccessfulVisits: 0,
      SupervisorInspections: [],
      selectedInspection: null,
      search: null,
      searchOps: null
    };
  },
  components: {
    Widget,
    DataTable,
    TimeLine,
    LocationStatistic,
    SiteViewStatistic,
    TotalEarningsStatistic
  },
  computed: {
    computedDateFormatted() {
      return this.formatStartDate(this.startDate);
      return this.formatEndDate(this.endDate);
    }
  },
  watch: {
    startDate(val) {
      this.startDateFormatted = this.formatStartDate(this.startDate);
    },
    endDate(value) {
      this.endDateFormatted = this.formatEndDate(this.endDate);
    }
  },
  mounted() {
    let self = this;
    let tokenDecoded = JWT.decode(localStorage.accessToken);
    console.log("[TOKEN DECODED]", tokenDecoded);

    self.userID = localStorage.getItem("USER_ID");
    console.log("USER_ID", self.userID);
    self.role = localStorage.getItem("Role");
    console.log("ROLE", self.role);

    var date = new Date();
    self.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
      .toISOString()
      .substr(0, 10);
    self.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      .toISOString()
      .substr(0, 10);

    self.FetchCustomers(self.role, self.userID);
  },
  methods: {
    showImage(id) {
      let self = this;
      console.log("[SHOW IMAGE]", id);
      self.showPhoto = true;
      let address = self.$Config.ServerAddress;
      self.photoUrl = `${address}Photo/Stream?id=${id}`;
    },
    FetchCustomers(role, userID) {
      let self = this;

      let url;

      switch (role.toLowerCase()) {
        case "master":
          {
            url = `Customer`;
          }
          break;
        case "admin":
          {
            url = `Customer`;
          }
          break;
        default:
          {
            url = `Customer/GetBySystemUser?systemUserID=${self.userID}`;
          }
          break;
      }

      if (role == "Master" || role == "Admin") {
        self
          .get(`Customer`)
          .then(response => {
            self.customerItems = response.data;
            console.log("[CUSTOMER ITEMS]", self.customerItems);
          })
          .catch(error => {
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText(error.toString());
          });
      } else {
        self
          .get(`Customer/GetBySystemUser?systemUserID=${self.userID}`)
          .then(response => {
            self.customerItems = response.data;
            console.log("[CUSTOMER ITEMS]", self.customerItems);
          })
          .catch(error => {
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText(error.toString());
          });
      }
    },
    FetchVenues() {
      let self = this;

      self.$nextTick(() => {
        self
          .get(
            `CustomerVenue/CustomerID?customerID=${self.selectedCustomer.ID}`
          )
          .then(r => {
            console.log("[VENUE ITEMS FOR CUSTOMER]", r.data);
            self.venueItems = r.data;
          });
      });
    },
    filterItems() {
      let self = this;

      self.superVisorItems = [];
      self.opsManagerItems = [];
      if (self.selectedCustomer.ID != null && self.selectedVenue.ID != null) {
        self.$refs.Loader.show(true);
        self.$refs.Loader.setText("Filtering items...");
        console.log("SELECTED DATES", self.startDate, self.endDate);
        self.menu2 = false;
        self.getCheckIns();
        self.getSupervisorTotalTasks();
        self.getOpsTotalTasks();
        self.getCompleteVsIncomplete();
        self.getSupervisorTasks();
        self.getOpsManagerTasks();
        self.GetSupervisorInspections();

        setTimeout(() => {
            self.$refs.Loader.hide();
        }, 2000);
      }
    },
    clearFilter() {
      let self = this;
      self.selectedCustomer = null;
      self.selectedVenue = null;
      self.opsManagerItems = [];
      self.superVisorItems = [];
      self.CheckInsForToday = 0;
      self.SupervisorInspectionsCompletedToday = 0;
      self.OpsInspectionsCompletedToday = 0;
      self.CompleteIncomplete.Efficiency = "";
    },
    getCheckIns() {
      let self = this;

      // TODO GET FOR OTHER ROLES/USER
      if (self.role == "Master" || self.role == "Admin") {
        self
          .get(
            `SQLReporting/TotalCheckInsByVenue?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
          )
          .then(r => {
            self.CheckInsForToday = r.data.length;
          });
      }
    },
    GetSupervisorInspections() {
      let self = this;
      self.SupervisorInspections = [];
      console.log("[VENUE ID]", self.selectedVenue.ID);
      console.log("[START DATE]", self.startDate);
      console.log("[END DATE]", self.endDate);

      self
        .get(
          `SQLReporting/SupervisorTasks/Summary?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          console.log("[SUPERVISOR SUMMARY]", r.data);
          var NumCompleted = 0;
          var NumIncomplete = 0;

          r.data.forEach(inspection => {
            self.SupervisorInspections.push({
              Reference: inspection.SupervisorAllocatedInspection.Reference,
              CustomerInspectionID: inspection.CustomerInspection.ID,
              Name: inspection.CustomerInspection.Name,
              InspectionData: null,
              AmountComplete: inspection.TotalComplete,
              AmountIncomplete: inspection.TotalIncomplete
            });
          });
        });
    },
    GetSupervisorInspectionItemTXes(item) {
      let self = this;
      self.superVisorItems = [];
      console.log("Get txes by item", item);

      self
        .get(
          `SQLReporting/SupervisorInspectionItems?venueID=${self.selectedVenue.ID}&inspectionID=${item.CustomerInspectionID}&startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          //console.log("r.data", r.data)
          r.data.forEach(el => {
            if (el.Reference == item.Reference) {
              el.Date = moment(el.Date).format("YYYY-MM-DD hh:mm:ss");
              self.superVisorItems.push(el);
            }
          });
        })
        .catch(e => {
          console.error(e.toString());
        });
    },
    getSupervisorTotalTasks() {
      let self = this;

      var inspectionCompletedCount = 0;
      self.SupervisorInspectionsCompletedToday = 0;
      // TODO GET FOR OTHER ROLES/USER
      if (self.role == "Master" || self.role == "Admin") {
        self
          .get(
            `SQLReporting/TotalSupervisorTasks?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
          )
          .then(r => {
            console.log("[SUPERVISOR TASKS]", r.data);
            r.data.forEach(el => {
              inspectionCompletedCount =
                inspectionCompletedCount + el.TotalJobsComplete;
            });
            self.SupervisorInspectionsCompletedToday = inspectionCompletedCount;
            console.log(
              "SUPERVISOR TASKS COMPLETED",
              self.SupervisorInspectionsCompletedToday
            );
          });
      }
    },
    getOpsTotalTasks() {
      let self = this;

      self
        .get(
          `SQLReporting/TotalOpsInspectionTasks?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          console.log("OPS MANAGER TOTAL", r);
          self.OpsInspectionsCompletedToday = r.data[0].TotalCustomerVisits;
        });
    },
    getCompleteVsIncomplete() {
      let self = this;

      self
        .get(
          `SQLReporting/SupervisorCompleteVsInComplete?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          console.log("[COMPLETE VS INCOMPLETE]", r);

          self.CompleteIncomplete.Complete = r.data[0].TotalComplete;
          self.CompleteIncomplete.Incomplete = r.data[0].TotalIncomplete;
          self.$nextTick(() => {
            self.CompleteIncomplete.Total =
              self.CompleteIncomplete.Complete +
              self.CompleteIncomplete.Incomplete;

            if (self.CompleteIncomplete.Total > 0) {
              self.CompleteIncomplete.Efficiency =
                parseFloat(
                  (self.CompleteIncomplete.Complete /
                    self.CompleteIncomplete.Total) *
                    100
                ).toFixed(2) + "%";
            }
          });

          console.log("COMPLETE/INCOMPLETE", self.CompleteIncomplete);
        });
    },
    getSupervisorTasks() {
      let self = this;
      self.SupervisorTasksComplete = 0;
      self.SupervisorTasksIncomplete = 0;

      self
        .get(
          `SQLReporting/SupervisorTasks?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          console.log("[SUPERVISOR TASKS FOR TABLE]", r.data);
          //self.superVisorItems = r.data;

          r.data.forEach(task => {
            task.Date = moment(task.Date).format("YYYY-MM-DD hh:mm:ss");

            if (task.Comments == null || task.Comments.length == 0) {
              task.Comments = "No comments submitted";
            }

            if (task.Completed == true) {
              self.SupervisorTasksComplete = self.SupervisorTasksComplete + 1;
            } else if (task.Completed == false) {
              self.SupervisorTasksIncomplete =
                self.SupervisorTasksIncomplete + 1;
            }
          });

          self.SupervisorEfficiency =
            parseFloat(
              (self.SupervisorTasksComplete /
                (self.SupervisorTasksComplete +
                  self.SupervisorTasksIncomplete)) *
                100
            ).toFixed(2) + "%";
          console.log(
            "[NUMBER OF SUPERVISOR TASKS COMPLETED]",
            self.SupervisorTasksComplete
          );
          console.log(
            "[NUMBER OF SUPERVISOR TASKS INCOMPLETE]",
            self.SupervisorTasksIncomplete
          );
          console.log("[SUPERVISOR EFFICIENCY]", self.SupervisorEfficiency);
        });
    },
    getOpsManagerTasks() {
      let self = this;
      self.OpsManagerTasksComplete = 0;
      self.OpsManagerTasksIncomplete = 0;
      self.OpsSuccessfulVisits = 0;
      self.OpsUnsuccessfulVisits = 0;

      self
        .get(
          `SQLReporting/OpsManagerTasks?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          console.log("[OPS-MANAGER] TASKS FOR TABLE", r.data);
          self.opsManagerItems = r.data;
          self.opsManagerItems.forEach(task => {
            task.DateTime = moment(task.DateTime).format("YYYY-MM-DD");

            task.OpsRating = task.OpsRating + "/5";

            if (task.Complete == true && task.Type == 2) {
              self.OpsManagerTasksComplete = self.OpsManagerTasksComplete + 1;
            } else if (task.Complete == false && task.Type == 2) {
              self.OpsManagerTasksIncomplete =
                self.OpsManagerTasksIncomplete + 1;
            }

            if (task.Inspection == null) {
              task.Inspection = "N/A";
            }

            if (task.Type == 1) {
              task.Type = "Customer Visit";
              task.OpsRating = "N/A";
            } else if (task.Type == 2) {
              task.Type = "Inspection";
            }

            if (task.CustomerComments == null) {
              task.CustomerComments = "N/A";
            }

            if (task.OpsComments == null) {
              task.OpsComments = "N/A";
            }

            if (task.CustomerRating == 1) {
              task.CustomerRating = "Good";
            } else if (task.CustomerRating == 0) {
              task.CustomerRating = "Bad";
            }

            if (task.CustomerRating == "Bad" && task.Type == "Inspection") {
              task.CustomerRating = "N/A";
            }

            if (task.Complete == false) {
              task.CustomerRating = "N/A";
            }

            if (task.OpsRating == null) {
              task.OpsRating = 0;
            }

            if (task.Type == "Customer Visit" && task.Complete == true) {
              self.OpsSuccessfulVisits = self.OpsSuccessfulVisits + 1;
            } else if (
              task.Type == "Customer Visit" &&
              task.Complete == false
            ) {
              self.OpsUnsuccessfulVisits = self.OpsUnsuccessfulVisits + 1;
            }
          });
          self.OpsManagerEfficiency =
            parseFloat(
              (self.OpsManagerTasksComplete /
                (self.OpsManagerTasksComplete +
                  self.OpsManagerTasksIncomplete)) *
                100
            ).toFixed(2) + "%";

          console.log(
            "[NUMBER OF OPSMANAGER TASKS COMPLETED]",
            self.OpsManagerTasksComplete
          );
          console.log(
            "[NUMBER OF OPSMANAGER TASKS INCOMPLETE]",
            self.OpsManagerTasksIncomplete
          );
          console.log("[OPSMANAGER EFFICIENCY]", self.OpsManagerEfficiency);
        });
    },
    // DATE FILTERING
    parseDate(date) {
      let self = this;
      console.log("PARSED DATE", date);
    },
    filterByDate() {
      let self = this;
      var labels = [];
      var data = [];

      console.log("[FILTER START DATE]", self.startDate);
      console.log("[FILTER END DATE]", self.endDate);
    },
    formatStartDate(startDate) {
      if (!startDate) return null;

      const [year, month, day] = startDate.split("-");
      return `${month}/${day}/${year}`;
    },
    formatEndDate(endDate) {
      if (!endDate) return null;

      const [year, month, day] = endDate.split("-");
      return `${month}/${day}/${year}`;
    },
    parseStartDate(startDate) {
      if (!startDate) return null;

      const [month, day, year] = startDate.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    parseEndDate(endDate) {
      if (!endDate) return null;

      const [month, day, year] = endDate.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>

<style scoped>
.active {
  border-style: solid;
  border-color: rgb(0, 0, 0) !important;
}

table {
  border-collapse: collapse;
  width: 100%;
  font-family: sans-serif;
}

table,
th,
td {
  border: 1px solid rgb(199, 199, 199);
  border-left: 0px !important;
  border-right: 0px !important;
  font-size: 13px;
  text-align: left;
}

th {
  padding: 5px 0px;
}

td {
  border-bottom: 0px !important;
  font-size: 12px;
  padding: 0px 2px;
}
</style>